// src/components/ForgotPasswordPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Form, Button, Card, Container, Alert } from 'react-bootstrap';
import {SERVER_BASE_URL} from "../Constants";

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(SERVER_BASE_URL + 'api/users/forgot-password', { email });
            if (response.status === 200) {
                setMessage('If an account with that email exists, you will receive a password reset link.');
                setError('');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'An error occurred. Please try again.');
            setMessage('');
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center p-5">
            <Card style={{ width: '22rem' }} className="p-4 shadow">
                <Card.Title className="text-center">Forgot Password</Card.Title>

                {message && <Alert variant="success">{message}</Alert>}
                {error && <Alert variant="danger">{error}</Alert>}

                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Button variant="outline-primary" type="submit" className="w-100">
                        Reset Password
                    </Button>

                    <div className="mt-3 text-center">
                        <small>
                            <a href="/login">Back to Login</a>
                        </small>
                    </div>
                </Form>
            </Card>
        </Container>
    );
};

export default ForgotPassword;
